import React from 'react';
import VerificationInput from 'react-verification-input';
import './CodeInputField.scss'; // Import as global CSS instead of CSS modules

const VerificationCodeInput = ({ type, fields, value, onChange }) => {
  return (
    <VerificationInput
      value={value || ''}
      length={fields}
      validChars={type === 'number' ? '0-9' : undefined}
      placeholder=""
      autoFocus
      onChange={onChange}
      classNames={{
        container: 'reactCodeInput',
        character: 'character',
        characterInactive: 'characterInactive',
        characterSelected: 'characterSelected',
        characterFilled: 'characterFilled',
      }}
      inputProps={{
        inputMode: type === 'number' ? 'numeric' : 'text',
      }}
    />
  );
};

export default VerificationCodeInput;